
const localstoreValue = JSON.parse(localStorage.getItem("@socialcam/modoModeracao"))
const state = () => ({
    modoModeracao: localstoreValue ? localstoreValue : 0
})

const getters = {
    getModoModeracao: state => {
        return state.modoModeracao;
    }
}

const actions = {
    setModoModeracao({ commit }, value) {
        try {
            commit("setModoModeracao", value)
        } catch(error) {
            return error
        }
    }
}

const mutations = {
    setModoModeracao(state, value) {
        state.modoModeracao = value
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}